import { graphql } from 'graphql-schema';

const GET_USER_NOTIFICATION_PREFERENCES = graphql(`
  query UserNotificationPreferences($userId: uuid!) {
    user_notification_preferences(where: { user: { _eq: $userId } }, limit: 1) {
      _id
      marketing_email
      marketing_push
      marketing_sms
      team_email
      team_push
      team_sms
    }
  }
`);

export default GET_USER_NOTIFICATION_PREFERENCES;
